import { useSelector } from 'react-redux';
import { RootState } from './store';
import LayoutBase from './components/layout/LayoutBase';
import LoadingSpinner from './components/common/LoadingSpinner';
import { getUnauthorizedUserUrl } from './configurations/environmentVariables';
import LoginRedirect from './pages/LoginRedirect';
import { getBaseUrl } from './configurations/environmentVariables';
import { useAuth } from './hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { USUARIO_ACCESO_PRE, USUARIO_ACCESO_PRO } from './types/users/rolesTypes';

const App = () => {

    // Auth hook
    const { user, hasIdToken, isLoading, isError, error, logout } = useAuth();
    const { roles } = user;

    const validateAppAuthorization = (roles: string[]) => {
        switch (process.env.REACT_APP_ENVIRONMENT) {

            case "PRE":
                return (roles.includes(USUARIO_ACCESO_PRE));

            case "PRO":
                return (roles.includes(USUARIO_ACCESO_PRO));

            default:
                return true;
        }
    }
    const tieneAcceso = validateAppAuthorization(roles);
    const state = useSelector((state: RootState) => state);
    const { LayoutActive } = state.layoutmode;
    const href = window.location.href;

    useEffect(() => {
        if (isError && error && hasIdToken) {
            <Navigate to={`/error/500`} />
        }
    }, [isError, error, hasIdToken]);

    // Methods
    if (isLoading) {
        return (<LoadingSpinner />);
    }

    if (!roles || roles.length === 0) {
        return (<LoadingSpinner />);
    }

    if (!tieneAcceso) {
        window.location.replace(getUnauthorizedUserUrl());
        return null;
    }

    const setLayout = () => {

        if (LayoutActive !== "") {

            return (
                <>
                    <LayoutBase user={user} mode={LayoutActive} logout={logout} />
                    <LoginRedirect user={user} mode={LayoutActive} />
                </>
            );

        } else {
            if (href.includes(`${getBaseUrl()}/ranking/`)) {

                return (<LayoutBase user={user} mode={"rank"} logout={logout} />);

            } else if (href.includes(`${getBaseUrl()}/objetivos/`)) {

                return (<LayoutBase user={user} mode={"obj"} logout={logout} />);

            } else {

                return (<LayoutBase user={user} mode={""} logout={logout} />);
            }
        }
    };

    // Render
    return setLayout();
}

export default App;